module.exports = __webpack_public_path__ + "2026310:ef9a7edf554eddff21f3/img/sol-logo-guys-we-fcked.0861a0b.png";